module.exports = __webpack_public_path__ + "img/lejon.536470d5.png";